import { initComponentStore } from "@/utils/mobx";
import { appStore } from "@/app_store";
import { ApiServerError } from "@/utils/api";


export class SignInSectionStore {
    email: string = "";
    password: string = "";
    error: string | null = null;
    isLoading: boolean = false;

    constructor() {
        initComponentStore(this);
    }

    setEmail(value: string) {
        this.email = value;
        this.error = null;
    }

    setPassword(value: string) {
        this.password = value;
        this.error = null;
    }

    async submit() {
        if (!this.email || !this.password) {
            this.error = "Please fill in all fields.";
            return;
        }
        this.isLoading = true;
        this.error = null;
        try {
            await appStore.account.signIn(this.email, this.password);
        } catch (e) {
            if (e instanceof ApiServerError) {
                this.error = e.message;
            } else {
                this.error = "Connection error. Please try again.";
            }
        } finally {
            this.isLoading = false;
        }
    }
}
